// extracted by mini-css-extract-plugin
module.exports = {"CPS-store-message":"CPS-store-message-672ed7643f7478a9b5bab4f3ab8c4e2b","store-message-left":"store-message-left-1a014099f600588c4a6e858bf0f224d7"};